/**
 * Nutzungsordnung für Poolfahrzeuge — Text + Versionsstring (Issue #163).
 *
 * Wird sowohl vom Client (Modal-Anzeige) als auch vom Server (Assert-Gate im
 * Reservierungs-Flow) importiert — gemeinsamer Ort, damit UI und Backend
 * garantiert auf dieselbe Version referenzieren.
 *
 * Beim Update der Nutzungsordnung Version hochzählen — der Unique-Constraint
 * (fahrzeug_id, mitarbeiter_id, version) in nutzungsordnung_bestaetigungen
 * sorgt dafür, dass jeder Mitarbeiter die neue Version erneut bestätigen muss.
 */

export const NUTZUNGSORDNUNG_VERSION = '2026-01';

export const NUTZUNGSORDNUNG_TEXT = `# Nutzungsordnung Poolfahrzeug

**Version ${NUTZUNGSORDNUNG_VERSION}**

## 1. Geltungsbereich

Diese Nutzungsordnung gilt für alle von der Gutachter Koop & Partner mbB
(nachfolgend „Betreiber") bereitgestellten Poolfahrzeuge. Jeder Mitarbeiter,
der ein Poolfahrzeug reserviert oder führt, muss die Nutzungsordnung vor
Erstnutzung zur Kenntnis genommen und per Klick bestätigt haben.

## 2. Reservierung

- Reservierungen erfolgen ausschließlich über das Buchungsmodul der App.
- Doppelbuchungen werden durch die Datenbank abgelehnt.
- Der Mitarbeiter gibt bei der Buchung Zweck, Ziel und voraussichtlichen
  Rückgabezeitpunkt an.
- Bei Bedarf ist der Zeitraum rechtzeitig zu verlängern.

## 3. Fahrzeugübergabe und Rückgabe

- Vor der ersten Fahrt: Zustandscheck (Karosserie, Tank-/Ladestand, Reifen).
- Bei Rückgabe: Fahrzeug gereinigt, mindestens halbvoll / geladen (>50 %),
  Schlüsselabgabe am vereinbarten Ort.
- Schäden, auch Bagatellschäden, sind UNVERZÜGLICH zu melden.

## 4. Protokollpflichten (Fahrtenbuch)

- Jede Fahrt wird im Fahrtenbuch (digital via GPS oder manuell) festgehalten:
  Beginn- und Endzeit, Start- und Zielort, gefahrene Kilometer und Zweck.
- Die Kategorisierung „dienstlich / Arbeitsweg / privat" ist wahrheitsgemäß
  auszuwählen. Steuerrechtlich relevant (§ 8 Abs. 2 EStG, 1-%- bzw.
  Fahrtenbuch-Regel).

## 5. Privatnutzung

- Privatnutzung ist nur zulässig, wenn für das jeweilige Fahrzeug ausdrücklich
  freigegeben (Markierung "privatnutzung_erlaubt = true").
- Bei Poolfahrzeugen mit BLP > 70.000 € greift die 0,5 %-Regelung —
  lückenloses Fahrtenbuch ist dann Pflicht.

## 6. Verbote

- Alkohol, andere berauschende Mittel oder Fahren ohne gültige Fahrerlaubnis
  führen zu sofortigem Nutzungsverbot.
- Rauchen im Fahrzeug ist untersagt.
- Die Weitergabe des Fahrzeugs oder Schlüssels an Dritte, die nicht im
  System als Nutzer hinterlegt sind, ist nicht gestattet.

## 7. Unfälle und Schäden

- Unfallort sichern, Polizei bei Personenschaden oder Streitigkeiten rufen.
- Unverzüglich den Betreiber informieren und Schadenbericht erstellen.
- Der Mitarbeiter haftet grob fahrlässig oder vorsätzlich verursachte Schäden
  entsprechend der arbeitsvertraglichen Regelungen.

## 8. GPS und Datenverarbeitung

- Dienst- und Poolfahrzeuge werden per GPS-Tracker erfasst. Die Daten dienen
  der Erstellung des Fahrtenbuchs und der Flottensteuerung.
- Die Auswertung erfolgt DSGVO-konform — Einzelbewegungsprofile werden nicht
  zur Verhaltens- oder Leistungskontrolle genutzt.

## 9. Bestätigung

Mit Klick auf „Bestätigen" bestätigt der Mitarbeiter, dass er diese
Nutzungsordnung gelesen, verstanden und zur Kenntnis genommen hat. Zeitstempel,
IP-Adresse und User-Agent werden zur Beweissicherung gespeichert.
`;
